import React, {useContext} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {AuthContext} from '../../contexts/auth/context';
import {AuthContextType} from '../../contexts/auth/types';
import {ScreenPaths} from '../../enums/screen-path';

interface Props {
  path: string;
  children: React.ReactNode;
}

/**
 * HOC used for our private routes.
 */
const PrivateRoute: React.FC<Props> = ({children, ...rest}) => {
  // Get context
  const authContext: AuthContextType = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={({location}) => {
        const pathname = location.pathname.startsWith(ScreenPaths.DailyCareLog)
          ? ScreenPaths.LoginDailyCareLog
          : ScreenPaths.Login;

        return authContext.state.firebaseUser ? (
          children
        ) : (
          <Redirect
            to={{
              pathname,
              state: {from: location},
            }}
          />
        );
      }}
    />
  );
};
export default PrivateRoute;
